import { MouseEventHandler } from "react";
import "./style.css";
import { ReactNode } from "react";

export interface ButtonProps {
    onClick?: MouseEventHandler<HTMLSpanElement>;
    iconName?: string
    additionalClass?: string
    title?: string
    text?: ReactNode
    preset?:
    | "default" | "fill" | 'bordered' | 'successBtn' | 'trashBin'
    image?: string
    imageStyle?:string
}

export const PRESETS = {
    default: "./style.css",
    fill: "fill",
    bordered: 'bordered',
    successBtn: 'successBtn',
    trashBin: 'trashBin'
};

function NoteneticButton(props: ButtonProps) {
        const { onClick, additionalClass, text, preset, iconName, image, imageStyle, title, ...others } = props;
    return (
        <button
            className={preset ? PRESETS[preset] : PRESETS['default'] + additionalClass}
            onClick={onClick}
            title={title}
        >
            {iconName && <i className={iconName}></i>}
            {image &&
                <img
                    src={image}
                    className={imageStyle}
                    style={{ maxWidth: "15px", marginBottom:"4px" }}
                />
            }
            {text && <span className="pl-1">{text}</span>}
        </button>
    );
}

export default NoteneticButton;
